module.exports = __webpack_public_path__ + "img/earning.c4bf9f4c.svg";